import classes from './scePSCheckBox.scss';

const Checkbox = function (props) {
    let spanFocus = '0';
    let inputFocus = '-1';
    if (props.focusOnCheckBoxIcon) {
        spanFocus = '-1';
        inputFocus = '0';
    }
    let checkBoxLabelElement, border, checkBoxStyle, formContainerBorder;
    let isChecked = props.selectedOptions;

    const handleKeyPress=(event)=>{ 
        if(event.which===32 || event.which===13){
            props.handleClick();  
            event.preventDefault();
        }
    };

    if (props.type === 'simpleCheckBox') {
        checkBoxLabelElement =  <span className='sr-only'>{props.id}</span>;
        checkBoxStyle = classes.sceCheckboxSimple;
    }
    // Transparent Background for simple checkbox, used in Move center module.
    else if(props.type === 'moveCenterCheckBox'){
        checkBoxLabelElement = <span className='sr-only'>{props.id}</span>;
        checkBoxStyle = classes.sceCheckboxMoveCenter;
    }
    else {
        border = props.selectedOptionIcon ? classes.successBorder : null;
        checkBoxStyle = props.isSelectAllCheck ? classes.sceSelectAllCheck : classes.sceCheckbox;
        formContainerBorder = classes.defaultBorder;
        checkBoxLabelElement = props.options;
    }

    return (
        <div>
            <div className={'sce-checkbox '+checkBoxStyle + ' ' + border} >
                <input checked={isChecked} onClick={props.handleClick} type="checkbox" id={props.id} disabled={props.disabled} />
                <label htmlFor={props.id}  onKeyPress={(event)=>handleKeyPress(event)} className="sce-checkBox-text" >{checkBoxLabelElement}</label>
            </div>
        </div>
    );
};
export default Checkbox;
